import { InjectionToken } from '@angular/core';

export interface FeatureFlagsConfig {
  ticketFilters: { showHeader: boolean };
  syndicateFilters: { showHeader: boolean };
  global: {
    usDateFormat: boolean; // US app date format - as they are different
    fantasyStatsModalClass: string; // class for modals
    sheetModalBetslip: boolean; // WIP
    haveCustomAppBetslip: boolean; // Default no, this is present only in US app
    disableContentSwitcher: boolean; // remove content switcher from syndicates create
    haveXpoint: boolean; // xpoint geolocation for US
    FantasyOUSummary: boolean; // summary, will be for US
    FantasyMarginSummary: boolean; // summary, will be for US
    haveQuickDeposit: boolean; // Default no, this is present only in US app
    poolListCardType?: string; // if pool list will have card format as in US. options: list OR card
    betAgeVerify: boolean; // if we present to verify before placing a bet
    poolsPageFreePlayBanner: boolean; // if we have the freeplay banner on pools list page also
    haveBetBuilder?: boolean; // if product have bet-builder,
    betAgeVerification?: boolean; // if product has bet age verification
    hasNewWallet?: boolean; // if product has new wallet
    isFantasy?: boolean; // if product is fantasy
  };
}

export const DEFAULT_LIB_CONFIG: FeatureFlagsConfig = {
  ticketFilters: { showHeader: true },
  syndicateFilters: { showHeader: true },
  global: {
    usDateFormat: false,
    fantasyStatsModalClass: 'stats-modal',
    sheetModalBetslip: false,
    haveCustomAppBetslip: false,
    disableContentSwitcher: false,
    haveXpoint: false,
    FantasyOUSummary: false,
    FantasyMarginSummary: false,
    haveQuickDeposit: false,
    poolListCardType: 'list',
    betAgeVerify: false,
    poolsPageFreePlayBanner: false,
    haveBetBuilder: false,
    betAgeVerification: false,
    hasNewWallet: false,
    isFantasy: false,
  },
};

export const FEATURE_FLAGS_CONFIG_TOKEN = new InjectionToken<
  Partial<FeatureFlagsConfig>
>('FeatureFlagsConfigToken');
